import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "virtual-private-server-automated-script"
    }}>{`Virtual Private Server (Automated Script)`}</h1>
    <p>{`With this tutorial, you can install PickBazar to any type of blank or empty ubuntu server. For example, `}<inlineCode parentName="p">{`Digital Ocean Droplets, Amazon Lightsail, AWS, Google Cloud Virtual Private Server, Azure Ubuntu Virtual Private Server`}</inlineCode>{`, etc.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you want to use all the scripts (`}<inlineCode parentName="p">{`shop`}</inlineCode>{`, `}<inlineCode parentName="p">{`admin`}</inlineCode>{`, `}<inlineCode parentName="p">{`api`}</inlineCode>{`) on the same server as this tutorial, then we recommend creating a blank ubuntu-based (`}<inlineCode parentName="p">{`v20.0.4 lts`}</inlineCode>{`) server with at least 2+ CPU cores and 2GB+ memory.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Please follow this video with the documentation, and it'll make the installation process relatively easy.`}</p>
    </blockquote>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/TsDd_Qewe2c" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h3 {...{
      "id": "prerequisite"
    }}>{`Prerequisite`}</h3>
    <blockquote>
      <p parentName="blockquote">{`This automated script is for the *nix system. So if you are using mac or Linux, then you're good to go. But if you are using windows, then install WSL on your computer and use this script using `}<a parentName="p" {...{
          "href": "https://www.youtube.com/watch?v=_fntjriRe48"
        }}>{`WSL`}</a>{` or follow this `}<a parentName="p" {...{
          "href": "/vps-server-manual"
        }}>{`manual installation`}</a></p>
    </blockquote>
    <p>{`Before starting, the procedure ensures that NodeJS 16 (the latest) is installed on your computer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm i -g yarn zx
`}</code></pre>
    <p>{`Now you can follow the script installation procedure,`}</p>
    <h4 {...{
      "id": "at-first-login-your-server-from-terminal"
    }}>{`At first login your server from terminal`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`ssh SERVER_USERNAME@SERVERIP
`}</code></pre>
    <h4 {...{
      "id": "upload-api-and-deployment-project-to-virtual-server-form-youp-pc---run-on-local-pc"
    }}>{`Upload api and deployment project to Virtual Server form youp PC - RUN on Local PC`}</h4>
    <p>{`To upload the zipped `}<inlineCode parentName="p">{`deployment`}</inlineCode>{` files to server you need to run the below command form your pickbazar project root`}</p>
    <blockquote>
      <p parentName="blockquote">{`while running below command you will asked for enter your server `}<inlineCode parentName="p">{`username`}</inlineCode>{` and `}<inlineCode parentName="p">{`ip address`}</inlineCode>{` by entering and a successful connection you will also asked for enter your `}<inlineCode parentName="p">{`deployment.zip`}</inlineCode>{`
files path and the path will be look like `}<inlineCode parentName="p">{`/home/your_project_folder_path/pickbazar-react/deployment.zip`}</inlineCode></p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    bash deployment/deployment.sh
`}</code></pre>
    <h4 {...{
      "id": "server-environment-setup-script---run-on-virtual-server"
    }}>{`Server Environment setup script - RUN on Virtual Server`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    bash /var/www/pickbazar-react/deployment/nodesetup.sh
`}</code></pre>
    <h4 {...{
      "id": "nginx-setup-and-settings---run-on-virtual-server"
    }}>{`Nginx Setup And Settings - RUN on Virtual Server`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    zx /var/www/pickbazar-react/deployment/setenv.mjs
`}</code></pre>
    <h4 {...{
      "id": "run-backend-api----run-on-virtual-server"
    }}>{`Run Backend API  - RUN on Virtual Server`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    zx /var/www/pickbazar-react/deployment/backendrun.mjs
`}</code></pre>
    <h4 {...{
      "id": "frontend-build-script---run-on-local-pc"
    }}>{`Frontend build script - RUN on Local PC`}</h4>
    <p>{`Run the below command from your pickbazar-react project root`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    zx deployment/frontendbuildscript.mjs
`}</code></pre>
    <h4 {...{
      "id": "frontend-run-script---run-on-virtual-server"
    }}>{`Frontend run script - RUN on Virtual Server`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    zx /var/www/pickbazar-react/deployment/frontendrunscript.mjs
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      